import moment, { Moment } from 'moment'

export function urlToList(url: string): string[] {
  const urllist = url.split('/').filter(i => i)
  return urllist.map((urlItem, index) => {
    return `/${urllist.slice(0, index + 1).join('/')}`
  })
}
export function getSearchValue(search: string) {
  const params = new URLSearchParams(search)
  return params.get('id') // bar
}


export function updateArrayItem<T extends { id: number }>(data: T[], item: T): T[] {
  return data.map(i => (i.id === item.id ? item : i))
}

export function formatValue(value?: any, formart?: string) {
  if (!formart || formart === null || formart === undefined || formart === '') return value
  if (!value || value === null || value === undefined || value === '') return ''

  if (typeof value === 'number') {
    value = value.toString()
  }
  if (formart.includes('#')) {
    return formatNumber(value, formart)
  } else if (formart.includes('yyyy')) {
    try {
      value = new Date(value)
      return format(value, formart)
    } catch (e) {
      console.warn(e)
      return ''
    }
  }
}

export function formatDateTime(date?: string) {
  if (!date || date === undefined) return ''
  if (typeof date === 'string') return date.split('.')[0].replace('T', ' ')
  return ''
}

export function dateDiff(type: string, bgnDate: string, endDate: string) {
  let date1 = new Date(formatDateTime(bgnDate).replace(/-/g, '/'))
  let date2 = new Date(formatDateTime(endDate).replace(/-/g, '/'))
  let date3 = date2.getTime() - new Date(date1).getTime()
  switch (type) {
    case 'd':
      let dayDiff = Math.floor(date3 / (24 * 3600 * 1000))
      return dayDiff
    case 'h':
      let hours = Math.floor(date3 / (3600 * 1000))
      return hours
    case 'm':
      let minutes = Math.floor(date3 / (60 * 1000))
      return minutes
    case 's':
      let seconds = Math.round(date3 / 1000)
      return seconds
    default:
      return dayDiff
  }
}

export function formatDate(date?: string) {
  if (!date) return ''
  if (typeof date === 'string') return date.split('T')[0]
  return ''
}

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)

export function toTreeData(data: any) {
  let cache = {}
  let treeData = []
  for (let item of data) {
    item.children = []
    let parentItem = cache[item.parentId]
    if (parentItem) {
      parentItem.children.push(item)
    } else {
      treeData.push(item)
    }
    cache[item.id] = item
  }
  return treeData
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
export function format(date: Date, fmt: any) {
  // author: meizz
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
  return fmt
}

export function GetQueryString(name: string) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = location.search.substr(1).match(reg) // search,查询？后面的参数，并匹配正则
  if (r != null) return decodeURI(r[2])
  return null
}

export function GetQueryStringByUrl(url: string, name: string) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = url.match(reg) // search,查询？后面的参数，并匹配正则
  if (r != null) return decodeURI(r[2])
  return null
}

export const appFormat = (value?: string, fmt?: string) => {
  if (stringIsNull(fmt)) return value || ''
  if (stringIsNull(value)) return ''
  if (fmt.includes('#')) return appNumber.format(value, fmt)
  return appDate.format(value, fmt)
}

export function stringIsNull(value: string) {
  if (value && value !== undefined && value !== null && value !== '') return false
  return true
}

export const appDate = {
  // YYYY-MM-DD HH:mm:ss 注意大小写
  format: (value?: string, fmt?: string) => {
    if (stringIsNull(value)) return ''
    fmt = fmt || 'YYYY-MM-DD'
    let res = moment(value).format(fmt)
    return res === 'Invalid date' ? '' : res
  },

  returnValue: (value?: string) => {
    if (stringIsNull(value)) return null
    return new Date(value).toISOString()
  },

  string: (momentValue: Moment, fmt?: string) => {
    if (momentValue === null) return '';
    fmt = fmt || 'YYYY-MM-DD'
    return momentValue.format(fmt);
  },

  moment: (value?: string) => {
    if (stringIsNull(value)) return null
    return moment(value)
  },
}

export const appString = {
  forbidChars: (chars?: string, value?: string) => {
    if (stringIsNull(chars) || stringIsNull(value)) return false
    let reg = RegExp('[' + chars + ']')
    return reg.test(value)
  },

  clearForbidChars: (chars?: string, value?: string) => {
    if (appString.forbidChars(chars, value)) {
      let reg = RegExp('[' + chars + ']')
      return value.replace(reg, '')
    } else {
      return value || '';
    }

  },
}

export const appNumber = {
  format: (value?: string, fmt?: string) => {
    if (stringIsNull(value)) return ''
    fmt = fmt || '#,###.00'
    return formatNumber(value, fmt)
  },

  checkAndFormat: (value: string, fmt?: string) => {
    if (value === '') return '';
    if (isNaN(parseFloat(value.replace(/,/g, "")))) return '';
    return appNumber.format(value, fmt);
  },

  returnValue: (value: string, dataType?: string) => {
    if (stringIsNull(value)) return null
    dataType = dataType || 'float'
    value = value.replace(/,/, '')
    return dataType === 'float' ? parseFloat(value) : parseInt(value, 10)
  },

  toNumber: (value: string) => {
    if (value === null || isNaN(parseFloat(value))) return null;
    return parseFloat(value)

  }
}

export function formatNumber(value: string, formart?: string) {
  if (value === '' || value === null || value === undefined) return ''

  formart = formart || '#,###.00'
  let arrFormart = formart.split('.')

  // 获取小数位
  let act = 0
  if (arrFormart.length === 2) act = arrFormart[1].length
  value = value.toString().replace(/,/g, '')
  //  是否格式化 ,是否包含千分号
  if (!formart.includes(',')) return parseFloat(value).toFixed(act)

  act = act >= 0 && act <= 20 ? act : 2

  value = parseFloat((value + '').replace(/[^\d\.-]/g, '')).toFixed(act) + ''
  let arrValue = value.split('.')
  let arrValueInteger = arrValue[0].split('').reverse()
  let valueDecimal = formart.includes('.') ? arrValue[1] : ''

  let valueIntegerFormat = ''
  for (let i = 0; i < arrValueInteger.length; i++) {
    valueIntegerFormat += arrValueInteger[i] + ((i + 1) % 3 === 0 && i + 1 !== arrValueInteger.length ? ',' : '')
  }
  return (
    valueIntegerFormat
      .split('')
      .reverse()
      .join('') + (valueDecimal === '' ? '' : '.' + valueDecimal)
  )
}

export const initPageMode = () => {
  let mode = GetQueryString('mode')
  if (!(mode && mode !== null)) {
    mode = '3'
  }
  return Number(mode)
}
export const initPageId = () => {
  let id = GetQueryString('id')
  if (!(id && id !== null)) {
    id = '0'
  }
  return Number(id)
}

export const appOption = {
  formartValue: (dataType: string, value: string | number | boolean): string | number => {
    if (dataType === 'boolean') return value ? '1' : '0'
    if (dataType === 'number') return Number(value)
    return (value && value.toString()) || ''
  },
  getValue: (dataType: string, value: string | number | boolean): string | number | boolean => {
    if (dataType === 'boolean') return value === '1'

    return value
  },
}

export function isNumberType(type: any) {
  const lower = type.toLowerCase()
  return (
    lower.indexOf('int') !== -1 ||
    lower.indexOf('float') !== -1 ||
    lower.indexOf('double') !== -1 ||
    lower.indexOf('numeric') !== -1
  )
}
export function isDateType(type: any) {
  const lower = type.toLowerCase()
  return lower.indexOf('date') !== -1
}

export function toTreeDataByField(data: any, keyField: any, parentField: any) {
  let cache = {}
  let treeData = []
  for (let item of data) {
    item.children = []
    let parentItem = cache[item[parentField]]
    if (parentItem) {
      parentItem.children.push(item)
    } else {
      treeData.push(item)
    }
    cache[item[keyField]] = item
  }
  return treeData
}

export const appTree = {
  format: (treeList: any[], parentId?: string, id?: string) => {
    parentId = parentId || 'parentId';
    id = id || 'id';
    let cloneList: any[] = JSON.parse(JSON.stringify(treeList)); // 数据深度克隆
    cloneList.map((item: any) => {
      item._tree_children = cloneList.filter(child => child[parentId] === item.id) || [];
      item._tree_end = item._tree_children.length === 0
      item._tree_level = 0
      item._tree_code = ''
      // 是否是最顶级
      item._tree_top = (cloneList.filter(father => father[id] === item[parentId]).length === 0)
    })
    return cloneList.filter(ret => ret._tree_top);
  },

  list: (treeList: any[], parentId?: string, id?: string) => {
    let formatList = appTree.format(treeList, parentId, id)
    let returnList = [] as any[];
    const recFunction = (list: any[], level: number, parentCode?: string) => {
      list.forEach((item: any, index: number) => {
        item._tree_level = level
        item._tree_code = item._tree_top ? `_top${index}.` : `${parentCode}${index}.`
        returnList.push(item)

        item._tree_children
          && item._tree_children.length > 0
          && recFunction(item._tree_children, item._tree_level + 1, item._tree_code)
      })
    }
    recFunction(formatList, 1)
    return returnList;
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.ts